import moment from 'moment';
import { Button } from 'primereact/button';
import Control from '../../components/UI/Control/Control';
import GeneralMessage from '../../components/UI/GeneralMessage';

const AuditGridFilter = ({ hook }) => {
    const {
        registerValidationFor,
        onSubmit,
        generalErrorList,
        fieldErrorFor,
        control,
        filerEntityTypes,
    } = hook;

    return (
        <form className="container-fluid" noValidate onSubmit={onSubmit}>
            <GeneralMessage errorList={generalErrorList} />
            <div className="row">
                <div className="col-3">
                    <Control
                        error={fieldErrorFor.after?.message}
                        registerRef={registerValidationFor?.after}
                        control={control}
                        name="after"
                        type="datepicker"
                        label="From date"
                        value={moment().subtract(7, 'days')._d}
                        showTime
                    />
                </div>
                <div className="col-3">
                    <Control
                        error={fieldErrorFor.before?.message}
                        registerRef={registerValidationFor?.before}
                        control={control}
                        name="before"
                        type="datepicker"
                        label="To date"
                        value=""
                        showTime
                    />
                </div>
                <div className="col-3">
                    <Control
                        error={fieldErrorFor.entityType?.message}
                        registerRef={registerValidationFor?.entityType}
                        control={control}
                        name="entityType"
                        type="select"
                        label="Entity type"
                        options={filerEntityTypes}
                        value=""
                    />
                </div>
                <div className="col-2 d-flex align-items-center">
                    <Button
                        style={{ marginTop: '8px' }}
                        type="submit"
                        className="add-btn"
                        icon="fa fa-search"
                        label="Search"
                        tooltipOptions={{ position: 'top' }}
                    />
                </div>
            </div>
        </form>
    );
};

export default AuditGridFilter;
